'use client';
import { jsx } from 'react/jsx-runtime';
import t from 'prop-types';
import { useRef, useCallback, useEffect } from 'react';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { useAnchorBarIsPinned, useAnchorBarScroll } from './anchor-bar.hooks.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
let f = {
    sticky: t.bool,
    onActiveAnchorChanged: t.func
}, m = Object.keys(f);
const AnchorBar = renderWithRef('AnchorBar', f, (r, a)=>{
    useComponentStylesLoaded('AnchorBar', SWAN_STYLE_KEY_MAP.anchorBar);
    let { children: f, sticky: b = false, onActiveAnchorChanged: y } = r, d = useRef(null), [O] = useAnchorBarIsPinned(d, null != b && b);
    useAnchorBarScroll(d, {
        sticky: null != b && b,
        pinned: O,
        setActiveAnchor: useCallback((e)=>{
            y && y(e);
        }, [
            y
        ])
    });
    let h = new Set([
        'swan-anchor-bar'
    ]);
    b && h.add('swan-anchor-bar-sticky'), O && h.add('swan-anchor-bar-sticky-pinned');
    let j = assignRefs(a, d);
    return useEffect(()=>{
        if (!d.current) return;
        let e = '--swan-internal-anchor-bar-el-height';
        if (O) {
            let r = d.current.offsetHeight;
            document.documentElement.style.setProperty(e, `${r}px`);
        } else document.documentElement.style.removeProperty(e);
    }, [
        O
    ]), jsx(RenderComp, {
        root: "div",
        forwardedRef: j,
        propKeysToRemove: m,
        classNames: h,
        props: _object_spread_props(_object_spread({}, r), {
            darkMode: r.darkMode,
            role: 'navigation'
        }),
        children: f
    });
});

export { AnchorBar };
